var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTapProject5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 3,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03418 11.0977C6.52637 11.0977 6.06901 11.0065 5.66211 10.8242C5.25846 10.6387 4.93945 10.3815 4.70508 10.0527C4.47396 9.72396 4.35514 9.35286 4.34863 8.93945H5.96973C5.97624 9.11198 6.02669 9.26497 6.12109 9.39844C6.21875 9.52865 6.34733 9.62956 6.50684 9.70117C6.66634 9.77279 6.84212 9.80859 7.03418 9.80859C7.25228 9.80859 7.44759 9.75977 7.62012 9.66211C7.7959 9.56445 7.93099 9.42936 8.02539 9.25684C8.12305 9.08105 8.17025 8.88086 8.16699 8.65625C8.17025 8.42839 8.12305 8.22656 8.02539 8.05078C7.92773 7.875 7.79102 7.73828 7.61523 7.64062C7.43945 7.54297 7.23926 7.49414 7.01465 7.49414C6.764 7.49414 6.55241 7.54297 6.37988 7.64062C6.21061 7.73503 6.07715 7.87826 5.97949 8.07031H4.48535L4.83691 3.92969H9.3584V5.27734H6.2041L6.03809 6.9668H6.08691C6.21061 6.76823 6.40267 6.60872 6.66309 6.48828C6.9235 6.36458 7.21647 6.30273 7.54199 6.30273C7.96842 6.30273 8.35091 6.40202 8.68945 6.60059C9.02799 6.7959 9.29329 7.06934 9.48535 7.4209C9.68066 7.76921 9.77832 8.16471 9.77832 8.60742C9.77832 9.08919 9.66276 9.51888 9.43164 9.89648C9.20378 10.2741 8.88151 10.5687 8.46484 10.7803C8.05143 10.9919 7.57454 11.0977 7.03418 11.0977Z",
    fill: "#19191B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapProject5);
export default __webpack_public_path__ + "static/media/tap_project5.3eb41e325cbb737fc48cec5da76df30e.svg";
export { ForwardRef as ReactComponent };